import React from "react";
import { Col, Row, Carousel } from "react-bootstrap";

const chunkArray = (array, chunkSize) => {
  let result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};

const renderCarouselItems = (pages, chunkSize, handleRedirectClick, type) => {

  const chunks = chunkArray(pages, chunkSize);
  return chunks.map((chunk, index) => (
    <Carousel.Item key={index}>
      <Row className="gx-3">
        {chunk.map((page) => (
          <Col
            key={page.id}
            lg={3}
            xs={6}
            onClick={() => {
              if (type) {
                localStorage.setItem("generatorType", type);
                handleRedirectClick(page.id);
              } else {
                handleRedirectClick(page.id);
              }
            }}
          >
            <div className="d-flex justify-content-center cursor-pointer template-card">
              <img
                className="cursor-pointer"
                src={page.image}
                alt={`Template Card${page.id}`}
                loading="lazy"
              />
            </div>
          </Col>
        ))}
      </Row>
    </Carousel.Item>
  ));
};
export default renderCarouselItems